import React from 'react';
import classNames from 'classnames';

import style from './style/index.scss';

/**
 * React component to render bar that has a background color depending on the risk
 * and a text that shows the risk
 *
 * @param {Object} props - props object
 * @param {number} props.riskAssessment - risk assessment
 * @param {string} props.label - risk label
 *
 * @returns {JSX.Element} - risk bar
 */
export function RiskBar(props) {
    const { riskAssessment, label } = props;

    return (
        <div className={classNames(style.container, riskAssessment)}>
            {label}
        </div>
    );
}
